// in the context of a general fatal error, we can't get this information from services
// it has to be either hardcoded in the front bundle or injected in HTML backendside
export const SUPPORT_EMAIL = 'sgmarketsfx@sgcib.com';

export const SCREENSHOT_QUALITY = 0.1; // low quality, trying to avoid status 413 from sendHelpRequest service
